import { WhatsappEditTemplate } from 'types/templates';
import { TemplateVarsDataItem } from 'types/templates/templates-menu';
import { varsRegular } from 'utils/regexes';

/** משמש ב-TemplatePreviewSidebar ובקטלוג — בניית ערכי דוגמה לפרמטרים לתצוגה מקדימה */
export function buildTemplatePreviewVarsData(selectedTemplate: WhatsappEditTemplate | null): TemplateVarsDataItem[] {
  if (!selectedTemplate) return [];

  const data: TemplateVarsDataItem[] = [];

  const bodyComponent = selectedTemplate.components?.find((comp) => comp.type === 'BODY');
  if (bodyComponent?.text) {
    const bodyVariables = bodyComponent.text.match(varsRegular) || [];
    bodyVariables.forEach((variable, index) => {
      const variableNumber = variable.match(/\d+/)?.[0];
      if (variableNumber) {
        const defaultValue = bodyComponent.example?.body_text?.[0]?.[index] || '';
        const paramName = `body_${variableNumber}` as const;
        data.push({
          name: paramName as any,
          label: `{{${variableNumber}}}`,
          options: null,
          required: false,
          type: 'text',
          text: defaultValue,
        });
      }
    });
  }

  const headerComponent = selectedTemplate.components?.find((comp) => comp.type === 'HEADER');
  if (headerComponent?.text) {
    const headerVariables = headerComponent.text.match(varsRegular) || [];
    headerVariables.forEach((variable, index) => {
      const variableNumber = variable.match(/\d+/)?.[0];
      if (variableNumber) {
        const defaultValue = headerComponent.example?.header_text?.[0] || '';
        const paramName = `header_${variableNumber}` as const;
        data.push({
          name: paramName as any,
          label: `{{${variableNumber}}}`,
          options: null,
          required: false,
          type: 'text',
          text: defaultValue,
        });
      }
    });
  }

  const footerComponent = selectedTemplate.components?.find((comp) => comp.type === 'FOOTER');
  if (footerComponent?.text) {
    const footerVariables = footerComponent.text.match(varsRegular) || [];
    footerVariables.forEach((variable, index) => {
      const variableNumber = variable.match(/\d+/)?.[0];
      if (variableNumber) {
        const defaultValue = (footerComponent as any).example?.footer_text?.[0]?.[index] || '';
        const paramName = `footer_${variableNumber}` as any;
        data.push({
          name: paramName,
          label: `{{${variableNumber}}}`,
          options: null,
          required: false,
          type: 'text',
          text: defaultValue,
        });
      }
    });
  }

  return data;
}
